import { render, staticRenderFns } from "./InformationAlvaraAlterModal.vue?vue&type=template&id=6cd5f438&scoped=true"
import script from "./InformationAlvaraAlterModal.vue?vue&type=script&lang=js"
export * from "./InformationAlvaraAlterModal.vue?vue&type=script&lang=js"
import style0 from "./InformationAlvaraAlterModal.vue?vue&type=style&index=0&id=6cd5f438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd5f438",
  null
  
)

export default component.exports